import { useMutation, useQueryClient } from "@tanstack/react-query";

import { setPigletFeedInformation, setPigletFeedInformationAdmin } from "services";

import { footprintingPigletPrimaryQueryKeys, getEnvironment, invalidateAndRefecthQueries } from "utils";

import { FOOTPRINTING_PIGLET_FEED_INFORMATION } from "consts";

import { UploadablePigletFeedInformation } from "models";

export const useMutateFootprintingPigletFeedInformation = (farmId: string, year: number, payload: UploadablePigletFeedInformation[], primaryDataId: string) => {
  const isAdmin = getEnvironment().admin;
  const queryClient = useQueryClient();

  return useMutation(
    {
      mutationKey: [FOOTPRINTING_PIGLET_FEED_INFORMATION, primaryDataId, isAdmin],
      mutationFn: () => (isAdmin ? setPigletFeedInformationAdmin(primaryDataId, payload) : setPigletFeedInformation(primaryDataId, payload)),
      onSuccess: async () => {
        invalidateAndRefecthQueries(queryClient, [
          [FOOTPRINTING_PIGLET_FEED_INFORMATION, primaryDataId, isAdmin],
          ...footprintingPigletPrimaryQueryKeys(primaryDataId, farmId, year, isAdmin),
        ]);
      },
    },
    queryClient
  );
};
